// extracted by mini-css-extract-plugin
export default {"table":"qtas_table__+D2ti","buttonContainer":"qtas_buttonContainer__64fB8","addButton":"qtas_addButton__UbXly"};